import React, { useState, useRef, useEffect } from "react";

import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import swal from 'sweetalert'
import Axios from "axios";
import Config from "../../config.js"
import Typography from '@material-ui/core/Typography';

const CodeEditor = React.forwardRef((props, ref) => {
    const {
        questionId,
        buttonEnable,
        onClickCallBack,
        answerType,
        maxLength = 250,
        ...rest
    } = props;
    console.log(questionId)
    const [sendEnable, setSendEnable] = useState(buttonEnable)
    const [description, setDescription] = useState("")
    const [git, setGit] = useState("")
    function validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }
    useEffect(() => {
        setSendEnable(buttonEnable);
    }, [buttonEnable]);
    function handleShowValue() {
        var value = "-";
        if (answerType == 'git') {
            value = git;
            if ((!validURL(git) || !git.startsWith("http://git.sharifcamp.ir/"))) {
                return swal("آدرس اینترنتی نادرست است");
            }
        } else if (answerType == 'text') {
            if (description == "") {
                return swal("متنی وارد نشده است.");
            }
        }
        else if (answerType == 'yesno') {
            if (description == "") {
                return swal("گزینه ای انتخاب نشده است.");
            }
        }
    console.log("Send"+questionId)

        setSendEnable(false);
        Axios.post(Config.api + "Mpm/Answer", {
            questionId: questionId,
            description: description,
            value: value
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setSendEnable(true);
                swal("با موفقیت انجام شد.");
                setDescription("")
                setGit("")
                onClickCallBack(null, questionId);
            }).catch((err) => {
                if (err && err.response && err.response.status && err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err && err.response && err.response.status && err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err && err.response && err.response.status && err.response.status === 404) {
                    swal("هم اکنون مسابقه ای در جریان نیست.");
                    //props.history.push("/ICTChallenge");
                }
                else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
                setSendEnable(true);
            })
    }
    const handleTextBoxChangeDescription = (event) => {
        setDescription(event.target.value)

    };
    const handleTextBoxChangeGit = (event) => {
        setGit(event.target.value)
    };

    const select = {
        textAlign: 'right',
        direction: 'rtl',
        marginBottom: "20px"
    }
    const p = {
        marginRight: '10px',
    }
    const useStyles = makeStyles((theme) => ({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            width: '25ch',
        },
        hidden: {
            display: 'none'
        }
    }));
    const classes = useStyles();
    return (
        <div >
            <br />
            <br />
            <br />

            {(() => {
                if (answerType == 'git') {
                    return (
                        <div>
                            <div style={select} className={classes.root}>
                                <Typography variant="button" display="block" gutterBottom>
                                    ارسال پاسخ
                                </Typography>
                                <div style={{ clear: "both", display: "block", width: "100%" }}>

                                    <Typography variant="body2" gutterBottom display="block" >
                                        برای ارسال پاسخ و دریافت امتیاز سوال، کافی است لینک گیت مربوطه را وارد کرده و در صورتی که توضیحی مد نظرتان است، آن را وارد کنید. امکان ارسال مجدد را نیز دارید.
                                    </Typography>
                                </div>
                                <br />

                                <TextField
                                    className={answerType != 'git' ? 'hidden' : undefined}
                                    id="standard-full-width"
                                    label="آدرس گیت"
                                    style={{ margin: "25px 8px 8px 8px" }}
                                    placeholder="http://git.sharifcamp.ir/mpm/teamname"
                                    helperText="آدرس گیت را وارد کنید. مطمئن شوید مستقیما به پروژه اشاره می‌کنید."
                                    fullWidth
                                    value={git}
                                    onChange={handleTextBoxChangeGit}
                                    margin="normal"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.toString().slice(0, 250)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <TextField
                                    id="standard-full-width"
                                    label="توضیحات"
                                    style={{ margin: "25px 8px 8px 8px" }}
                                    placeholder=""
                                    helperText={"اگر به نظرتان نیاز است توضیحی برای تیم داوری ارسال کنید، لطفا بنویسید. (" + maxLength + " کاراکتر)"}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    onChange={handleTextBoxChangeDescription}
                                    value={description}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.toString().slice(0, maxLength)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                            </div><p>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={!sendEnable}
                                    onClick={handleShowValue}
                                >
                                    ثبت پاسخ
                                </Button>
                            </p>
                        </div>
                    )
                } else if (answerType == 'text') {
                    return (
                        <div>
                            <div style={select} className={classes.root}>
                                <Typography variant="button" display="block" gutterBottom>
                                    ارسال پاسخ
                                </Typography>
                                <div style={{ clear: "both", display: "block", width: "100%" }}>
                                    <Typography variant="body2" gutterBottom display="block" >
                                        آنچه در متن سوال خواسته شده است را به طور دقیق در باکس زیر وارد کنید. لطفا توجه داشته باشید بهترین پاسخ را برای سوال وارد کنید. امکان ارسال مجدد پاسخ را نیز دارید.
                                    </Typography>
                                </div>
                                <br />

                                <TextField
                                    id="standard-full-width"
                                    label="متن پاسخ"
                                    style={{ margin: "25px 8px 8px 8px" }}
                                    placeholder=""
                                    helperText={"پاسخی که برای این سوال در نظر دارید را وارد کنید توجه کنید محدودیت کاراکتر وجود دارد (" + maxLength + " کاراکتر)."}
                                    fullWidth
                                    margin="normal"
                                    multiline
                                    onChange={handleTextBoxChangeDescription}
                                    value={description}
                                    onInput={(e) => {
                                        e.target.value = e.target.value.toString().slice(0, maxLength)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                            </div>
                            <p>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={!sendEnable}
                                    onClick={handleShowValue}
                                >
                                    ثبت پاسخ
                                </Button>
                            </p>
                        </div>
                    )
                } else if (answerType == 'yesno') {
                    return (
                        <div>
                            <div style={select} className={classes.root}>
                                <Typography variant="button" display="block" gutterBottom>
                                    ارسال پاسخ
                                </Typography>
                                <div style={{ clear: "both", display: "block", width: "100%" }}>
                                    <Typography variant="body2" gutterBottom display="block" >
                                        این سوالات را با بله و خیر پاسخ دهید. امکان ارسال مجدد پاسخ را نیز دارید.
                                    </Typography>
                                </div>
                                <br />
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        style={{ margin: "25px 8px 8px 8px" }}
                                        aria-label="gender"
                                        fullWidth
                                        value={description}
                                        margin="normal"
                                        name="radio-buttons-group"
                                        onChange={handleTextBoxChangeDescription}
                                    >
                                        <FormControlLabel value="yes" control={<Radio />} label="بله" />
                                        <FormControlLabel value="no" control={<Radio />} label="خیر" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <p>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={!sendEnable}
                                    onClick={handleShowValue}
                                >
                                    ثبت پاسخ
                                </Button>
                            </p>
                        </div>
                    )
                }
            })()}


        </div>
    );
});


export default CodeEditor;
